import React from "react";
import "./DeleteAccount.css"; // opcional si quieres estilos aparte

function DeleteAccount() {
  return (
    <div className="delete-container">
      <h1>Eliminar Cuenta – ChefSkills</h1>

      <p>
        Si deseas solicitar la eliminación de tu cuenta de ChefSkills y todos los
        datos asociados, puedes escribirnos a:
      </p>

      <p className="delete-email">
        <strong>📧 chefskills.app@gmail.com</strong>
      </p>

      <h2>Datos que se eliminarán:</h2>
      <ul>
        <li>Cuenta de Firebase / Google</li>
        <li>Datos de perfil</li>
        <li>Favoritos</li>
        <li>Historial de compras</li>
        <li>Transacciones</li>
        <li>Suscripciones activas o caducadas</li>
        <li>Cualquier dato asociado a tu usuario</li>
      </ul>

      <h2>Tiempo de eliminación</h2>
      <p>
        Tu solicitud será procesada dentro de un plazo máximo de{" "}
        <strong>72 horas</strong>.
      </p>
    </div>
  );
}

export default DeleteAccount;
